import { randomNumber } from '../../../../utilities'
import { VentricularAssistDeviceConstants } from './ventricularAssistDevice.constants'
import { IVentricularAssistDeviceAction, IVentricularAssistDeviceState } from './ventricularAssistDevice.types'

export const initialVentricularAssistDeviceState: IVentricularAssistDeviceState = {
  key: randomNumber().toString(),
  date: '',
  time: '',
  pta: false,
  assessedBy: null,
  rolePerforming: null,
  ventricularAssistDeviceType: null,
  successfulAttempt: true,
  attempts: '1',
  procedureComplications: [],
  response: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  type: 'Ventricular Assist Device',
  isEkgImport: null,
  indication: null,
  pulsatilityIndex: '',
  auscultated: null,
  makeModelVad: null,
  makeModelImpella: null,
  pLevel: null,
  speedRpms: '',
  flowType: null,
  controllerNumber: '',
  motorCurrentMa: '',
  motorCurrentWaveformCharacteristics: null,
  placementSignalMmHg: '',
  placementSignalWaveformCharacteristics: null,
  placementConfirmedBy: null,
  catheterSize: null,
  catheterDepthCm: '',
  catheterSerialNumber: '',
  insertLocation: null,
  placementLocation: null,
  siteAssessment: [],
  legImmobilized: null,
  catheterSuturedInPlace: null,
  dressingCondition: '',
  pulsesDistalToInsertionSite: null,
  anchoringRingLocked: null,
  headOfBedAt30Degrees: null,
  anticoagulation: null,
  antidysrhythmia: null,
  purgeSolutionDextrosePercent: '',
  purgeSolutionHeparinIuMl: '',
  purgeSolutionFlowMlHr: '',
  pressureBagUsed: null,
  purgePressureMmHg: '',
  flowLMin: '',
  powerWatts: '',
  powerType: null,
  batteryStatus: null,
  backupOptions: null,
  alarms: null,
  vadCoordinatorNotification: null,
  inflowCannulaSiteAssessment: '',
  outflowCannulaSiteAssessment: '',
  nemsisCode: null,
  _hideVadFields: true,
  _hideImpellaFields: true,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
}

export function ventricularAssistDeviceReducer(
  state: IVentricularAssistDeviceState = initialVentricularAssistDeviceState,
  action: IVentricularAssistDeviceAction
): IVentricularAssistDeviceState {
  switch (action.type) {
    case VentricularAssistDeviceConstants.SET_DATE:
      return { ...state, date: action.date }
    case VentricularAssistDeviceConstants.SET_TIME:
      return { ...state, time: action.time }
    case VentricularAssistDeviceConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case VentricularAssistDeviceConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case VentricularAssistDeviceConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case VentricularAssistDeviceConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case VentricularAssistDeviceConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case VentricularAssistDeviceConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case VentricularAssistDeviceConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case VentricularAssistDeviceConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case VentricularAssistDeviceConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case VentricularAssistDeviceConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case VentricularAssistDeviceConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case VentricularAssistDeviceConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case VentricularAssistDeviceConstants.SET_VENTRICULAR_ASSIST_DEVICE_TYPE:
      return { ...state, ventricularAssistDeviceType: action.ventricularAssistDeviceType }
    case VentricularAssistDeviceConstants.SET_INDICATION:
      return { ...state, indication: action.indication }
    case VentricularAssistDeviceConstants.SET_PULSATILITY_INDEX:
      return { ...state, pulsatilityIndex: action.pulsatilityIndex }
    case VentricularAssistDeviceConstants.SET_AUSCULTATED:
      return { ...state, auscultated: action.auscultated }
    case VentricularAssistDeviceConstants.SET_MAKE_MODEL_VAD:
      return { ...state, makeModelVad: action.makeModelVad }
    case VentricularAssistDeviceConstants.SET_MAKE_MODEL_IMPELLA:
      return { ...state, makeModelImpella: action.makeModelImpella }
    case VentricularAssistDeviceConstants.SET_P_LEVEL:
      return { ...state, pLevel: action.pLevel }
    case VentricularAssistDeviceConstants.SET_SPEED_RPMS:
      return { ...state, speedRpms: action.speedRpms }
    case VentricularAssistDeviceConstants.SET_FLOW_TYPE:
      return { ...state, flowType: action.flowType }
    case VentricularAssistDeviceConstants.SET_CONTROLLER_NUMBER:
      return { ...state, controllerNumber: action.controllerNumber }
    case VentricularAssistDeviceConstants.SET_MOTOR_CURRENT_MA:
      return { ...state, motorCurrentMa: action.motorCurrentMa }
    case VentricularAssistDeviceConstants.SET_MOTOR_CURRENT_WAVE_FORM_CHARACTERISTICS:
      return { ...state, motorCurrentWaveformCharacteristics: action.motorCurrentWaveformCharacteristics }
    case VentricularAssistDeviceConstants.SET_PLACEMENT_SIGNAL_MMHG:
      return { ...state, placementSignalMmHg: action.placementSignalMmHg }
    case VentricularAssistDeviceConstants.SET_PLACEMENT_SIGNAL_WAVE_FORM_CHARACTERISTICS:
      return { ...state, placementSignalWaveformCharacteristics: action.placementSignalWaveformCharacteristics }
    case VentricularAssistDeviceConstants.SET_PLACEMENT_CONFIRMED_BY:
      return { ...state, placementConfirmedBy: action.placementConfirmedBy }
    case VentricularAssistDeviceConstants.SET_CATHETER_SIZE:
      return { ...state, catheterSize: action.catheterSize }
    case VentricularAssistDeviceConstants.SET_CATHETER_DEPTH_CM:
      return { ...state, catheterDepthCm: action.catheterDepthCm }
    case VentricularAssistDeviceConstants.SET_CATHETER_SERIAL_NUMBER:
      return { ...state, catheterSerialNumber: action.catheterSerialNumber }
    case VentricularAssistDeviceConstants.SET_INSERT_LOCATION:
      return { ...state, insertLocation: action.insertLocation }
    case VentricularAssistDeviceConstants.SET_PLACEMENT_LOCATION:
      return { ...state, placementLocation: action.placementLocation }
    case VentricularAssistDeviceConstants.SET_SITE_ASSESSMENT:
      return { ...state, siteAssessment: action.siteAssessment }
    case VentricularAssistDeviceConstants.SET_LEG_IMMOBILIZED:
      return { ...state, legImmobilized: action.legImmobilized }
    case VentricularAssistDeviceConstants.SET_CATHETER_SUTURED_IN_PLACE:
      return { ...state, catheterSuturedInPlace: action.catheterSuturedInPlace }
    case VentricularAssistDeviceConstants.SET_DRESSING_CONDITION:
      return { ...state, dressingCondition: action.dressingCondition }
    case VentricularAssistDeviceConstants.SET_PULSES_DISTAL_TO_INSERTION_SITE:
      return { ...state, pulsesDistalToInsertionSite: action.pulsesDistalToInsertionSite }
    case VentricularAssistDeviceConstants.SET_ANCHORING_RING_LOCKED:
      return { ...state, anchoringRingLocked: action.anchoringRingLocked }
    case VentricularAssistDeviceConstants.SET_HEAD_OF_BED_AT_30_DEGREES:
      return { ...state, headOfBedAt30Degrees: action.headOfBedAt30Degrees }
    case VentricularAssistDeviceConstants.SET_ANTICOAGULATION:
      return { ...state, anticoagulation: action.anticoagulation }
    case VentricularAssistDeviceConstants.SET_ANTIDYSRHYTHMIA:
      return { ...state, antidysrhythmia: action.antidysrhythmia }
    case VentricularAssistDeviceConstants.SET_PURGE_SOLUTION_DEXTROSE_PERCENT:
      return { ...state, purgeSolutionDextrosePercent: action.purgeSolutionDextrosePercent }
    case VentricularAssistDeviceConstants.SET_PURGE_SOLUTION_HEPARIN_IU_ML:
      return { ...state, purgeSolutionHeparinIuMl: action.purgeSolutionHeparinIuMl }
    case VentricularAssistDeviceConstants.SET_PURGE_SOLUTION_FLOW_ML_HR:
      return { ...state, purgeSolutionFlowMlHr: action.purgeSolutionFlowMlHr }
    case VentricularAssistDeviceConstants.SET_PRESSURE_BAG_USED:
      return { ...state, pressureBagUsed: action.pressureBagUsed }
    case VentricularAssistDeviceConstants.SET_PURGE_PRESSURE_MMHG:
      return { ...state, purgePressureMmHg: action.purgePressureMmHg }
    case VentricularAssistDeviceConstants.SET_FLOW_L_MIN:
      return { ...state, flowLMin: action.flowLMin }
    case VentricularAssistDeviceConstants.SET_POWER_WATTS:
      return { ...state, powerWatts: action.powerWatts }
    case VentricularAssistDeviceConstants.SET_POWER_TYPE:
      return { ...state, powerType: action.powerType }
    case VentricularAssistDeviceConstants.SET_BATTERY_STATUS:
      return { ...state, batteryStatus: action.batteryStatus }
    case VentricularAssistDeviceConstants.SET_BACKUP_OPTIONS:
      return { ...state, backupOptions: action.backupOptions }
    case VentricularAssistDeviceConstants.SET_ALARMS:
      return { ...state, alarms: action.alarms }
    case VentricularAssistDeviceConstants.SET_VAD_COORDINATOR_NOTIFICATION:
      return { ...state, vadCoordinatorNotification: action.vadCoordinatorNotification }
    case VentricularAssistDeviceConstants.SET_INFLOW_CANNULA_SITE_ASSESSMENT:
      return { ...state, inflowCannulaSiteAssessment: action.inflowCannulaSiteAssessment }
    case VentricularAssistDeviceConstants.SET_OUTFLOW_CANNULA_SITE_ASSESSMENT:
      return { ...state, outflowCannulaSiteAssessment: action.outflowCannulaSiteAssessment }
    case VentricularAssistDeviceConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case VentricularAssistDeviceConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case VentricularAssistDeviceConstants.SET_HIDE_VAD_FIELDS:
      return { ...state, _hideVadFields: action._hideVadFields }
    case VentricularAssistDeviceConstants.SET_HIDE_IMPELLA_FIELDS:
      return { ...state, _hideImpellaFields: action._hideImpellaFields }
    case VentricularAssistDeviceConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case VentricularAssistDeviceConstants.SET_STATE:
      return { ...action.ventricularAssistDeviceState, updateInputRows: true }
    case VentricularAssistDeviceConstants.CLEAR_FIELDS:
      return {
        ...state,
        indication: null,
        pulsatilityIndex: '',
        auscultated: null,
        makeModelVad: null,
        makeModelImpella: null,
        pLevel: null,
        speedRpms: '',
        flowType: null,
        controllerNumber: '',
        motorCurrentMa: '',
        motorCurrentWaveformCharacteristics: null,
        placementSignalMmHg: '',
        placementSignalWaveformCharacteristics: null,
        placementConfirmedBy: null,
        catheterSize: null,
        catheterDepthCm: '',
        catheterSerialNumber: '',
        insertLocation: null,
        placementLocation: null,
        siteAssessment: [],
        legImmobilized: null,
        catheterSuturedInPlace: null,
        dressingCondition: '',
        pulsesDistalToInsertionSite: null,
        anchoringRingLocked: null,
        headOfBedAt30Degrees: null,
        anticoagulation: null,
        antidysrhythmia: null,
        purgeSolutionDextrosePercent: '',
        purgeSolutionHeparinIuMl: '',
        purgeSolutionFlowMlHr: '',
        pressureBagUsed: null,
        purgePressureMmHg: '',
        flowLMin: '',
        powerWatts: '',
        powerType: null,
        batteryStatus: null,
        backupOptions: null,
        alarms: null,
        vadCoordinatorNotification: null,
        inflowCannulaSiteAssessment: '',
        outflowCannulaSiteAssessment: '',
        nemsisCode: null,
      }
    case VentricularAssistDeviceConstants.RESET_STATE:
      return {
        ...initialVentricularAssistDeviceState,
        key: randomNumber().toString(),
      }
    default:
      return state
  }
}
